import React, { FunctionComponent } from "react"
import Loader from "src/components/common/Loader"
import "./PositiveResponseFirstLoader.css"

const PositiveResponseFirstLoader: FunctionComponent<{}> = () => {
    return (
        <div className="PositiveResponseFirstLoader">
            <span id="positive-response-first-loader-span" className="material-icons">sync</span>
            <Loader id="positive-response-first-load-POS-loader" title="Fetching bad tickets..." />
        </div>
    )
}

export default PositiveResponseFirstLoader